import { type RenderMark } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const codeGray: RenderMark[string] = (text) => (
  <span className="flex justify-start border-b border-solid border-b-[#757575] pt-4 text-[0.8125rem]/[1.5625rem] font-medium text-[#757575]">
    {text}
  </span>
)
